<template>
  <validation-observer
    ref="observer"
    v-slot="{ handleSubmit }"
    tag="form"
  >
    <ui-modal
      :show="show"
      size="md"
      class="location-house-tip-outs-rename-modal"
      @before-close="reset"
      @closed="$emit('input', false)"
    >
      <template #title>
        <div class="text-center">
          {{ $t('houseTipOuts.renameTitle') }}
        </div>
      </template>

      <div class="mb-3 text-grey text-center">
        {{ $t('houseTipOuts.renameDescription') }}
      </div>

      <validation-provider
        tag="div"
        :name="$t('houseTipOuts.titleLabel')"
        rules="houseTipOutsName"
        mode="passive"
        v-slot="{ errors }"
      >
        <ui-input
          v-model="name"
          :label="$t('houseTipOuts.titleLabel')"
          maxlength="30"
          :counter="30"
          :error="errors[0]"
          @input="handleNameInput"
        >
          <template #infoBlock>
            <ui-button
              link
              type="primary"
              native-type="button"
              size="sm"
              @click.prevent="resetToHouse"
            >
              {{ $t('houseTipOuts.resetToHouse') }}
            </ui-button>
          </template>
        </ui-input>
      </validation-provider>

      <div class="p-3 mb-3 rounded bg-light">
        <div class="font-12 text-grey">
          {{ $t('houseTipOuts.exampleLabel') }}
        </div>
        <div class="mt-1 text-break">
          {{ exampleText }}
        </div>
      </div>

      <p class="text-grey font-12 mb-0">
        {{ $t('houseTipOuts.historyNote') }}
      </p>

      <template #footer="{ close }">
        <div class="d-flex w-100">
          <ui-button
            outline
            round
            size="sm"
            class="flex-fill mr-2"
            native-type="button"
            @click.prevent="close"
          >
            {{ $t('form.buttons.cancel') }}
          </ui-button>

          <ui-button
            round
            size="sm"
            type="primary"
            class="flex-fill"
            native-type="button"
            :disabled="!isApplyEnabled"
            @click.prevent="handleSubmit(apply)"
          >
            {{ $t('form.buttons.apply') }}
          </ui-button>
        </div>
      </template>
    </ui-modal>
  </validation-observer>
</template>

<script>
const DEFAULT_NAME = 'House';
const EXAMPLE_NAME = 'Name';

export default {
  name: 'LocationHouseTipOutsRenameModal',

  model: {
    prop: 'show',
    event: 'input',
  },

  props: {
    show: Boolean,
    currentName: {
      type: String,
      default: DEFAULT_NAME,
    },
  },

  data() {
    return {
      name: '',
    };
  },

  computed: {
    normalizedCurrentName() {
      return String(this.currentName ?? '').trim() || DEFAULT_NAME;
    },
    exampleText() {
      const title = String(this.name ?? '').trim() || EXAMPLE_NAME;
      return this.$t('houseTipOuts.exampleValue', { name: title });
    },
    isApplyEnabled() {
      return String(this.name ?? '').trim() !== this.normalizedCurrentName;
    },
  },

  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) {
          this.name = this.normalizedCurrentName;
          this.$nextTick(() => {
            this.$refs.observer.reset();
          });
        }
      },
    },
  },

  methods: {
    handleNameInput(value) {
      this.name = String(value ?? '').replace(/[^A-Za-z0-9 ]/g, '');
    },
    reset() {
      this.name = this.normalizedCurrentName;
      this.$refs.observer.reset();
    },
    resetToHouse() {
      this.name = DEFAULT_NAME;
      this.$refs.observer.reset();
    },
    apply() {
      const name = String(this.name ?? '').trim();

      if (!name) {
        return;
      }

      this.$emit('applied', name);
      this.$emit('input', false);
    },
  },
};
</script>
